import Response from './Response'
export class CONAPayloadResponse extends Response{
    Payload: string;
}

export default CONAPayloadResponse;